import {
    headerFunc
} from "./common/_header";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";
import {
  swiperFunc
} from "./common/_swiper";
import {
  facilityFunc
} from "./pages/_facility";
import {
  caseFunc
} from "./common/_case";
import {
  systemFunc
} from "./pages/_system";
import {
  recruitFunc
} from "./pages/_recruit";
import {
  individualFunc
} from "./pages/_individual";
import {
  contactFunc
} from "./pages/_contact";
import {
  emsFunc
} from "./pages/_ems";
import {
  scrollhintFunc
} from "./common/_scrollhint-init";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    if (document.querySelector('.js-top')) homeFunc();
    if (document.querySelector('.js-swiper')) swiperFunc();
    if (document.querySelector('.js-facility')) facilityFunc();
    if (document.querySelector('.js-case')) caseFunc();
    if (document.querySelector('.js-system')) systemFunc();
    if (document.querySelector('.js-recruit')) recruitFunc();
    if (document.querySelector('.js-individual')) individualFunc();
    if (document.querySelector('.js-contact')) contactFunc();
    if (document.querySelector('.js-ems')) emsFunc();
    if (document.querySelector('.js-scrollable')) scrollhintFunc();
});